/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sgrp_State_ControlInputs */

const en_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATE CONTROL`)
};

const ar_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحكم في الحالة`)
};

const bn_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টেট কন্ট্রোল`)
};

const de_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STAATLICHE KONTROLLE`)
};

const es_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTROL ESTATAL`)
};

const fr_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTRÔLE DE L'ÉTAT`)
};

const pt_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTROLE DE ESTADO`)
};

const zh_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态控制`)
};

const tr_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEVLET KONTROLÜ`)
};

const ru_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ГОСУДАРСТВЕННЫЙ КОНТРОЛЬ`)
};

const pl_sgrp_state_control = /** @type {(inputs: Sgrp_State_ControlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KONTROLA PAŃSTWA`)
};

/**
* | output |
* | --- |
* | "STATE CONTROL" |
*
* @param {Sgrp_State_ControlInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const sgrp_state_control = /** @type {((inputs?: Sgrp_State_ControlInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sgrp_State_ControlInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_sgrp_state_control(inputs)
	if (locale === "bn") return bn_sgrp_state_control(inputs)
	if (locale === "de") return de_sgrp_state_control(inputs)
	if (locale === "es") return es_sgrp_state_control(inputs)
	if (locale === "fr") return fr_sgrp_state_control(inputs)
	if (locale === "pt") return pt_sgrp_state_control(inputs)
	if (locale === "zh") return zh_sgrp_state_control(inputs)
	if (locale === "tr") return tr_sgrp_state_control(inputs)
	if (locale === "ru") return ru_sgrp_state_control(inputs)
	if (locale === "pl") return pl_sgrp_state_control(inputs)
	return en_sgrp_state_control(inputs)
});